// gloss
export const normalizeTabContent = (raw: unknown): string => {
  let htmlContent = '';

  if (typeof raw === 'object' && raw !== null && (raw as { html?: unknown }).html) {
    htmlContent = String((raw as { html: unknown }).html);
  } else {
    const rawString = typeof raw === 'string' ? raw : '';
    try {
      const parsedContent = typeof raw === 'string' ? JSON.parse(raw) : raw;
      htmlContent = parsedContent?.html || rawString;
    } catch (_parseError) {
      htmlContent = rawString;
    }
  }

  return htmlContent.trim().startsWith('<') ? htmlContent : `<p>${htmlContent}</p>`;
};
